var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoneyGradient = function SvgMoneyGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#moneyGradient_svg__a)",
    style: {
      mixBlendMode: "luminosity"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C9A377",
    d: "m7.63 21.063-6.216-4.852a.675.675 0 0 1-.115-.95L11.459 2.31a.68.68 0 0 1 .95-.116l6.214 4.852c.295.23.347.655.116.95L8.579 20.947a.68.68 0 0 1-.95.116"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#moneyGradient_svg__b)",
    d: "M5.226 21.919.473 14.836a.73.73 0 0 1 .2-1.016l14.815-9.918a.73.73 0 0 1 1.016.2l4.753 7.082a.73.73 0 0 1-.201 1.016L6.24 22.119a.73.73 0 0 1-1.015-.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.763 13.241A3.904 3.904 0 0 0 11.09 9.12a3.904 3.904 0 0 0-4.126 3.67 3.904 3.904 0 0 0 3.673 4.121 3.904 3.904 0 0 0 4.126-3.669"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1C38D",
    d: "M2.7 12.46a3.17 3.17 0 0 1-.868 4.4l-1.36-2.027a.73.73 0 0 1 .201-1.015zM3.869 19.895a3.177 3.177 0 0 1 4.405.86l-2.032 1.36a.733.733 0 0 1-1.017-.199zM19.029 13.557a3.17 3.17 0 0 1 .869-4.4l1.36 2.027a.73.73 0 0 1-.202 1.015zM17.86 6.123a3.176 3.176 0 0 1-4.405-.86l2.033-1.36a.733.733 0 0 1 1.017.199z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.768 10.052a.321.321 0 0 1-.18-.59l1.516-1.015a.322.322 0 0 1 .358.535l-1.516 1.015a.3.3 0 0 1-.178.055M4.447 17.63a.322.322 0 0 1-.18-.59l1.516-1.014a.322.322 0 0 1 .358.535l-1.516 1.015a.3.3 0 0 1-.178.054"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6A976",
    d: "m10.858 11.298.006.012c.182.069.336.183.474.367l.488-.266.25.459-.482.263q.356.925-.607 1.573l.006.012 2.42.65-1.07.582-2.555-.743-.218-.4.624-.34c.452-.246.65-.529.565-.88l-1.805.984-.25-.459 1.8-.98c-.246-.255-.587-.237-1.034.006l-1 .545-.288-.53 3.122-1.7.253.464z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "moneyGradient_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(128.588 4.83 5.987)scale(20.7777 22.9092)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "moneyGradient_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.333.908h21.333v21.333H.333z"
  })))));
};
export default SvgMoneyGradient;